import {
  LiveRoom,
} from '../live/define';
import { ANSWER_CORRECT_TYPE, Question } from '../question/define';
import { NumberTypeMap, StringTypeMap, TRUE_AND_FALSE } from '../base/define';
import { ACCESS_ROLE_TYPE, ChapterInfo } from '../course/define';

export enum UNIT_RESOURCE_TYPE {
  DEFAULT = 0,
  ALBUM = 1,
  MATERIAL = 2,
}

export enum UNIT_RESOURCE_SUBTYPE {
  BLUEPRINT = 1,
  MATERIAL,
}

export interface Folder {
  id?: number;
  name: string;
  hasUnit?: boolean;
  type: UNIT_RESOURCE_TYPE;
  subType?: UNIT_RESOURCE_SUBTYPE; // 针对type=2  1.图纸库  2.资料库
  resourceNumber?: number;
  relationCount?: number;
  relatedCourseFlag?: boolean;
}

export enum UnitContentType {
  REPORT,
  AIVideo, // 1 AI课
  Live, // 2 直播
  Homework, // 3 作业
  Audio, // 4 广播剧音频
  Material, // 5 学习资料
  ProjectTheme, // 6 作品主题
  MathLevel, // 7 数学关卡
}

export const UnitContentTypeMap: NumberTypeMap = {
  [UnitContentType.AIVideo]: 'AI课',
};

// -1:转码失败 0:初始化 1:上传成功，转码中 2:上传&转码成功
export enum VideoTransCodingStatus {
  Fail = -1,
  Init,
  Uploaded,
  Success
}

export enum UNIT_STATUS {
  RELEASED = 0,
  MODIFIED,
  DELETED,
  CREATED,
}

export enum RELATION_STATUS {
  NO_RELATION = 0,
  RELATION,
}

export interface Video {
  id: number;
  status: VideoTransCodingStatus;
  videoUrl: string;
  shdVideoUrl: string;
  fileName: string;
  duration: number;
  snapshotUrl: string;
  snapshotSec: number;
  customSnapshotUrl: string;
}

export enum AnchorType {
  // PureChoice = 0,
  // Url,
  // RedPacket,
  // Question,
  // Coupon,
  PURE_CHOICE = 0,
  URL,
  RED_PACKET,
  QUESTION,
  COUPON,
  QUESTION_GROUP,
}
export interface Anchor {
  id?: number;
  unitId: number;
  startTime: number;
  duration: number;
  remark?: string;
  type: AnchorType;
  enableAnimation: number;
  content: string;
  reward?: number;
  integral?: number; // 当前星力值数量
  isLive?: boolean;
  actionList?: Action[];
}

export enum ActionType {
  BREAK_POINT = 1,
}

export interface Action {
  key: string;
  value: string;
  type: ActionType;
}

export enum TemplateSyncStatus {
  Synced = 1,
  ToSync,
  Syncing,
  SyncFail
}

export enum QUESTION_OPERATE {
  ADD = 1,
  DELETE,
}

/**
 * @deprecated 请废弃当前枚举，使用SUBJECT_COMBINATION_TYPE。
 * 还保留，兼容可能存在的bug。
 */
export enum SUBJECT_TYPE {
  OTHER = 0,
  KADA = 1, // 1-1 编程；
  GO, // 2-1 围棋；
  THINKING, // 3-1: 思维; 3-2:乐高
  PAINTING, // 4-1 国画； 4-2 美术
  CHESS,
  PLAY,
  WRITING,
  PHYSICS,
  EXPERIMENT,
  PINYIN,
  MATH
}

export const SUBJECT_TYPE_MAP: NumberTypeMap = {
  [SUBJECT_TYPE.OTHER]: '其他',
  [SUBJECT_TYPE.KADA]: '编程',
  [SUBJECT_TYPE.GO]: '围棋',
  [SUBJECT_TYPE.THINKING]: '乐高',
  [SUBJECT_TYPE.PAINTING]: '美术',
  [SUBJECT_TYPE.CHESS]: '国象',
  [SUBJECT_TYPE.PLAY]: '趣玩',
  [SUBJECT_TYPE.WRITING]: '写字',
  [SUBJECT_TYPE.PHYSICS]: '物理',
  [SUBJECT_TYPE.EXPERIMENT]: '实验室',
  [SUBJECT_TYPE.PINYIN]: '拼音',
  [SUBJECT_TYPE.MATH]: '数学',
};

export enum SUBJECT_COMBINATION_TYPE { // subjectType-subType
  OTHER = '0-1', // 其他
  KADA = '1-1', // 编程
  GO = '2-1', // 围棋
  THINKING = '3-1', // 思维
  LEGO = '3-2', // 乐高
  SCIENCE = '3-3', // 其他
  PAINTING = '4-1', // 国画
  ART = '4-2', // 美术
  CHESS = '5-1', // 国象
  PLAY = '6-1', // 趣玩
  WRITING = '7-1', // 写字
  PHYSICS = '8-1', // 物理
  EXPERIMENT = '9-1', // 实验室
  PINYIN = '10-1', // 拼音课
  MATH = '11-1', // 数学课
}

export const SUBJECT_COMBINATION_TYPE_MAP: StringTypeMap = { // subjectType-subType
  [SUBJECT_COMBINATION_TYPE.OTHER]: '其他',
  [SUBJECT_COMBINATION_TYPE.KADA]: '编程',
  [SUBJECT_COMBINATION_TYPE.GO]: '围棋',
  [SUBJECT_COMBINATION_TYPE.THINKING]: '思维',
  [SUBJECT_COMBINATION_TYPE.LEGO]: '乐高',
  [SUBJECT_COMBINATION_TYPE.SCIENCE]: '科学',
  [SUBJECT_COMBINATION_TYPE.PAINTING]: '国画',
  [SUBJECT_COMBINATION_TYPE.ART]: '美术',
  [SUBJECT_COMBINATION_TYPE.CHESS]: '国象',
  [SUBJECT_COMBINATION_TYPE.PLAY]: '趣玩',
  [SUBJECT_COMBINATION_TYPE.WRITING]: '写字',
  [SUBJECT_COMBINATION_TYPE.PHYSICS]: '物理',
  [SUBJECT_COMBINATION_TYPE.EXPERIMENT]: '实验室',
  [SUBJECT_COMBINATION_TYPE.PINYIN]: '拼音',
  [SUBJECT_COMBINATION_TYPE.MATH]: '数学',
};

export interface UnitQuestion extends Question {
  firstAnswerRate?: string;
  lastAnswerRate?: string;
  operateType?: QUESTION_OPERATE;
}

export interface Breakpoint {
  id?: number;
  unitId: number;
  startTime: number;
  remark?: string;
  name: string;
  imageUrl?: string;
  needHide: boolean;
}

export interface LastAction {
  anchorId: number;
  actionKey: string;
  actionValue: string;
  gmtCreate: number;
  gmtModified: number;
}

export enum BREAKPOINT_SWITCH {
  Close = 0,
  Open,
}

export enum ONLINE_TYPE {
  IMMEDIATELY = 1,
  TIMING,
}

export const ONLINE_TYPE_MAP: NumberTypeMap = {
  [ONLINE_TYPE.IMMEDIATELY]: '立即上线',
  [ONLINE_TYPE.TIMING]: '定时上线',
};
export enum TRIAL_LEARN_FLAG {
  NO_SUPPORT,
  ALL,
  PART
}
export const TRIAL_LEARN_FLAG_MAP = {
  [TRIAL_LEARN_FLAG.NO_SUPPORT]: '不支持',
  [TRIAL_LEARN_FLAG.ALL]: '试学全部',
  [TRIAL_LEARN_FLAG.PART]: '试学部分',
};
export const TRIAL_LEARN_FLAG_BOOLEAN_MAP = {
  [TRIAL_LEARN_FLAG.NO_SUPPORT]: '不支持试学',
  [TRIAL_LEARN_FLAG.ALL]: '支持试学',
};

export interface KnowledgeItem {
  seq: number;
  value: string;
}

export interface Unit {
  id?: number;
  folderId?: number;
  chapterId?: number;
  relationCount?: number;
  name: string;
  folderName?: string;
  remarkName?: string;
  contentType: UnitContentType;
  ownerId?: number;
  ownerName?: string;
  contentId?: number;
  anchors?: Anchor[];
  video?: Video;
  audio?: Audio;
  status?: number;
  templateSyncStatus?: TemplateSyncStatus;
  releaseType?: number;
  releaseTime?: number;
  canSelect?: boolean;
  isSelect?: boolean;
  templateUnitId?: number;
  relationStatus?: number | null;
  roomList?: LiveRoom[];
  percent?: number;
  subjectType?: number;
  subType?: number;
  subjectCombinedType?: SUBJECT_COMBINATION_TYPE;
  questionList?: UnitQuestion[];
  questionCount?: number;
  breakpoints?: Breakpoint[];
  breakpointSwitch?: BREAKPOINT_SWITCH;
  coverPicture?: string;
  pictures?: Picture[];
  accessRoleType?: ACCESS_ROLE_TYPE;
  publishDuration?: number;
  playCount?: number;
  finishedRate?: number;
  onlineType?: ONLINE_TYPE;
  onlineTime?: number;
  trialLearnFlag?: TRIAL_LEARN_FLAG;
  trialLearnDuration?: number | null;
  knowledgeList?: KnowledgeItem[];
  hasFinish?: boolean;
  errorCount?: number;
  projectThemeId?: number;
  projectThemeName?: string;
  projectThemeType?: PROJECT_THEME_TYPE;
  uploadProjectSwitch?: TRUE_AND_FALSE;
  videoSizeType?: VIDEO_SIZE_TYPE;
  updateFlag?: TRUE_AND_FALSE;
  projectId?: number;
  projectContent?: string;
  videoBean?: Video;
  reviewTemplateList?: UnitReviewTemplate[];
  steamMathBean?: MathLevel;
}

export interface UnitReviewTemplate {
  seq?: number;
  content: string;
}

export enum DUB_TYPE {
  IMAGE = 1,
  TIMELINE,
}
export interface DubItem {
  type: DUB_TYPE;
  imgUrl?: string;
  timePoint?: number;
  voiceUrl?: string;
  dubCaption?: string;
  characterCaption?: string;
  identifyText?: string;
  recordingDuration?: number;
}
export interface ProjectThemeDubbing {
  id?: number;
  videoId?: number;
  video?: Video;
  dubItemList?: DubItem[];
}

export interface ProjectTheme extends ProjectThemeDubbing {
  id?: number;
  type: PROJECT_THEME_TYPE;
  supportType: number;
  nameForUnit: string;
  name: string;
  courseSeriesIds: string;
  showInWall: number;
  remark: string;
  notifyAudioUrl: string;
  bgImgUrl: string;
  isDeleted?: number;
  gmtCreate?: number;
  gmtModified?: number;
  totalProjectNumber?: number;
  selectedProjectNumber?: number;
  courseSeriesStr?: string;
  voiceIntroduceSwitch?: number;
}

export interface MathLevel {
  moduleId?: number;
  knowledgeId?: number;
  knowledgeItemId?: number;
  resourceName?: string;
}

export enum VIDEO_SIZE_TYPE {
  SIXTEEN_NINE = 1,
  FOUR_THREE,
}

export enum PROJECT_THEME_TYPE {
  IMAGE = 1,
  VIDEO,
  IMAGE_OR_VIDEO,
  DUBBING,
}

export const PROJECT_THEME_TYPE_MAP: NumberTypeMap = {
  [PROJECT_THEME_TYPE.IMAGE]: '图片',
  [PROJECT_THEME_TYPE.VIDEO]: '视频',
  [PROJECT_THEME_TYPE.IMAGE_OR_VIDEO]: '图片/视频',
  [PROJECT_THEME_TYPE.DUBBING]: '配音',
};

export enum USER_PROJECT_TYPE {
  IMAGE = 1,
  AUDIO,
  VIDEO,
  DUBBING,
}

export enum CORRECT_STATUS {
  UNDO,
  DONE
}

export interface UserProject {
  id?: number;
  projectThemeId: number;
  unitId: number;
  unitType: number;
  contentType: number;
  contentId: string;
  voiceIntroUrl: string;
  totalStar: number;
  isSelected: number;
  isDeleted: number;
  uploadTime: number;
  gmtCreate: number;
  gmtModified: number;
  thumbsUpFlag: boolean;
  userName: string;
  userHeaderImage: string;
  uid: number;
  projectThemeName: string;
  dealUrl?: string;
  tutorName: string;
  correctsStatus?: CORRECT_STATUS;
  correctsTime?: number;
  score?: SCORE;
  correctsTutorId?: number;
  correctsTutorName?: string;
  videoUrl?: string;
  videoId?: number;
  snapshotUrl?: string;
  videoBean?: Video;
  dubUrlList?: string[];
}

export interface UserProjectCorrectsInfo {
  id?: number; // 点评id
  projectId: number;
  projectThemeId: number;
  unitId: number;
  unitType: number;
  contentType: number;
  imgUrl: string;
  voiceIntroUrl: string;
  totalStar: number;
  isSelected: number;
  isDeleted: number;
  uploadTime: number;
  gmtCreate: number;
  gmtModified: number;
  thumbsUpFlag: boolean;
  userName: string;
  userHeaderImage: string;
  uid: number;
  phone?: number;
  projectThemeName: string;
  dealUrl?: string;
  tutorName: string;
  correctsStatus?: CORRECT_STATUS;
  correctsTime?: number;
  score?: SCORE;
  correctsTutorId?: number;
  correctsTutorName?: string;
  videoUrl?: string;
  videoId?: number;
  snapshotUrl?: string;
  wechatBindStatus?: number;
  consultantName?: string;
  videoBean?: Video;
  dubUrlList?: string[];
}
export interface UserUndealProject {
  id: number;
  contentId: string;
  userName?: string;
  uid: string;
  uploadTime: number;
  phone?: string;
  tutorName?: string;
  groupCode?: number;
  projectId: number;
}
export interface Picture {
  position: number;
  url: string;
}

export interface Audio {
  id?: number;
  url: string;
  name: string;
  duration: number;
  isDeleted?: number;
  gmtCreate?: number;
  gmtModified?: number;
}

export interface UnitRecord {
  uid: number;
  chapterId: number;
  lessonUnitId: number;
  unitName: string;
  percent: number;
  progress: number;
  count: number;
  finishTime?: number;
  gmtCreate: number;
}

export interface UnitLiveRecord {
  chapterNum: number;
  chapterName: string;
  liveLearnTime: number;
  videoLearnTime: number;
  roomSeq: number;
  roomName: string;
  firstEnterTime: number;
  lastExitTime: number;
  uid: number;
  chapterId: number;
}

export enum UnitType {
  Normal = 0,
  Template,
}

export interface UnitRequest extends Unit {
  isTemplateUnit: UnitType;
}

export interface MoveUnitRequest {
  folderId: number;
  unitId: number;
  targetFolderId: number;
  preUnitId: number;
}

export interface DeleteUnitRequest {
  unitId: number;
  isTemplateUnit: UnitType;
}

export enum LastSyncStatus {
  SyncFail = 0,
  Syncing,
  Synced,
}
export interface RelatedCourse {
  templateUnitId: number;
  unitId: number;
  lastSyncStatus: LastSyncStatus;
  lastSyncTime: number;
  courseName: string;
  courseId: number;
}

export interface RelatedAlbum {
  templateUnitId: number;
  unitId: number;
  lastSyncStatus: LastSyncStatus;
  lastSyncTime: number;
  albumName: string;
  albumId: number;
}

export interface UnbindRequest {
  templateUnitId: number;
  unitId: number;
  unbindRelease: number;
}

export interface CourseUnit {
  video: {
    shdVideoUrl: string;
    duration: number;
  };
  anchor: Anchor[];
  unit: {
    name: string;
    progress: number;
    percent: number;
    subjectType?: SUBJECT_TYPE;
    subType?: number;
    breakpointSwitch?: BREAKPOINT_SWITCH;
    pictures?: Picture[];
    chapterId?: number;
    parentUnitId?: number; // 回放时出现
    videoSizeType?: VIDEO_SIZE_TYPE;
  };
  breakpoints: Breakpoint[];
  lastActions: LastAction[];
}

export interface CourseUnitRequest {
  unitId: number;
  courseId?: number;
  isPreview?: number;
}

export interface QuestionUserAnswerRate {
  realName: string;
  courseId: number;
  courseName: string;
  homeworkId: number;
  uid: number;
  firstAnswerFlag: ANSWER_CORRECT_TYPE;
  lastAnswerFlag: ANSWER_CORRECT_TYPE;
  firstRecordId: number;
  lastRecordId: number;
}

export interface QuestionAnswerRate {
  unitId: number;
  questionId: number;
  questionName: string;
  firstCorrectRate: string;
  lastCorrectRate: string;
}

export enum SCORE {
  A_PLUS = 1,
  A,
  B_PLUS,
  B
}

export const SCORE_MAP: NumberTypeMap = {
  [SCORE.A_PLUS]: 'A+',
  [SCORE.A]: 'A',
  [SCORE.B_PLUS]: 'B+',
  [SCORE.B]: 'B',
};

// eslint-disable-next-line @typescript-eslint/class-name-casing
export interface submitCorrectsProjectRequest {
  projectId?: number;
  videoId?: number;
  score: SCORE;
}

export interface LearnResourceRelatedCourse {
  courseId: number;
  courseName: string;
  relationTime: number;
}

export enum LEARN_RESOURCE_SECTION_TYPE {
  QUESTION = 1,
  VIDEO,
  SPELL,
  IMAGE,
}
export interface LearnResourceSection {
  id?: number;
  sectionName: string;
  type: LEARN_RESOURCE_SECTION_TYPE;
  sectionContent: string;
  video?: Video;
}

export interface LearnResourceInfo {
  id?: number;
  name: string;
  categoryId: number;
  folderId: number;
  resourceImage: string;
  resourceSectionList?: LearnResourceSection[];
  relatedChapterId?: number;
}

export interface LearnResourceCategory {
  id?: number;
  name: string;
  folderId: number;
  position?: number;
}
export interface LearnResourceInfoInFolder extends LearnResourceCategory {
  resourceInfoList?: LearnResourceInfo[];
  publishedChapterList?: ChapterInfo[];
}

export interface LearnResourceInfoSecondary {
  categoryList: LearnResourceCategory[];
  resourceInfoList: LearnResourceInfo[];
}

export enum MOTION_TYPE {
  TRUMPET,
  WAVE,
}
